/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AddExternalOAuthServerRequestBody,
  AddExternalOAuthServerRequestBody$Outbound,
  AddExternalOAuthServerRequestBody$outboundSchema,
} from "../components/addexternaloauthserverrequestbody.js";

export type AddExternalOAuthServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type AddExternalOAuthServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type AddExternalOAuthServerSecurity = {
  option1?: AddExternalOAuthServerSecurityOption1 | undefined;
  option2?: AddExternalOAuthServerSecurityOption2 | undefined;
};

export type AddExternalOAuthServerRequest = {
  /**
   * The slug of the toolset to update
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  addExternalOAuthServerRequestBody: AddExternalOAuthServerRequestBody;
};

/** @internal */
export type AddExternalOAuthServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const AddExternalOAuthServerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    AddExternalOAuthServerSecurityOption1$Outbound,
    AddExternalOAuthServerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function addExternalOAuthServerSecurityOption1ToJSON(
  addExternalOAuthServerSecurityOption1: AddExternalOAuthServerSecurityOption1,
): string {
  return JSON.stringify(
    AddExternalOAuthServerSecurityOption1$outboundSchema.parse(
      addExternalOAuthServerSecurityOption1,
    ),
  );
}

/** @internal */
export type AddExternalOAuthServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const AddExternalOAuthServerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    AddExternalOAuthServerSecurityOption2$Outbound,
    AddExternalOAuthServerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function addExternalOAuthServerSecurityOption2ToJSON(
  addExternalOAuthServerSecurityOption2: AddExternalOAuthServerSecurityOption2,
): string {
  return JSON.stringify(
    AddExternalOAuthServerSecurityOption2$outboundSchema.parse(
      addExternalOAuthServerSecurityOption2,
    ),
  );
}

/** @internal */
export type AddExternalOAuthServerSecurity$Outbound = {
  Option1?: AddExternalOAuthServerSecurityOption1$Outbound | undefined;
  Option2?: AddExternalOAuthServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const AddExternalOAuthServerSecurity$outboundSchema: z.ZodMiniType<
  AddExternalOAuthServerSecurity$Outbound,
  AddExternalOAuthServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => AddExternalOAuthServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => AddExternalOAuthServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function addExternalOAuthServerSecurityToJSON(
  addExternalOAuthServerSecurity: AddExternalOAuthServerSecurity,
): string {
  return JSON.stringify(
    AddExternalOAuthServerSecurity$outboundSchema.parse(
      addExternalOAuthServerSecurity,
    ),
  );
}

/** @internal */
export type AddExternalOAuthServerRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AddExternalOAuthServerRequestBody: AddExternalOAuthServerRequestBody$Outbound;
};

/** @internal */
export const AddExternalOAuthServerRequest$outboundSchema: z.ZodMiniType<
  AddExternalOAuthServerRequest$Outbound,
  AddExternalOAuthServerRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    addExternalOAuthServerRequestBody:
      AddExternalOAuthServerRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      addExternalOAuthServerRequestBody: "AddExternalOAuthServerRequestBody",
    });
  }),
);

export function addExternalOAuthServerRequestToJSON(
  addExternalOAuthServerRequest: AddExternalOAuthServerRequest,
): string {
  return JSON.stringify(
    AddExternalOAuthServerRequest$outboundSchema.parse(
      addExternalOAuthServerRequest,
    ),
  );
}
